/* Auto generated file */
/* eslint-disable */
import { SVGSprite, type SVGSpriteProps } from '../svg/SVGBase';

const ACE = ({ color = 'primary', aspectRatio = '517/133', ...rest}: SVGSpriteProps) =>
    <SVGSprite use="ACE" aspectRatio={aspectRatio} color={color} {...rest} />;

export { ACE, ACE as default };
